import { JSONPath } from 'jsonpath-plus'

export const removeNonBreakSpaces = (string = '') => string.replace(/\s/g, ' ')

const getCategoriesForBreadcrumbs = (productData, breadcrumbs, dataMenu) => {
  if (breadcrumbs) return breadcrumbs
  if (productData && productData.categorias && productData.categorias.length > 0 && dataMenu.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    for (const category of productData.categorias) {
      const [level1Label, level2Label, level3Label] = removeNonBreakSpaces(category).split('/')

      if (level1Label && level2Label && level3Label) {
        const level1 = JSONPath({ path: `$[?(@.label=="${level1Label}")]`, json: dataMenu })[0]
        const level2 = JSONPath({
          path: `$[?(@.label=="${level1Label}")].categoriesLevel2[?(@.label=="${level2Label}")]`,
          json: dataMenu,
        })[0]
        const level3 = JSONPath({
          path: `$[?(@.label=="${level1Label}")].categoriesLevel2[?(@.label=="${level2Label}")].categoriesLevel3[?(@.label=="${level3Label}")]`,
          json: dataMenu,
        })[0]
        if (level1 && level2 && level3) {
          return {
            firstLevel: {
              label: level1.label,
            },
            secondLevel: {
              label: level2.label,
            },
            thirdLevel: {
              label: level3.label,
            },
          }
        }
      }
    }
  }
  return {}
}

export default getCategoriesForBreadcrumbs
